import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = void;
type Response = Car[];

// Org-scoped cars accepted by POST /internal/partners/reservations (+ /quote).
export const useOrganizationCars = createQuery<Response, Variables, AxiosError>({
  queryKey: ['internal/partners/organizations/cars'],
  fetcher: () =>
    client
      .get('v2/internal/partners/organizations/cars')
      .then((response) => response.data.data),
});
